<template>
  <div class="block">
    <div class="block-title header">
      <div class="title">推广计划管理</div>
      <el-button type="primary" @click="handleAddPlan">添加计划</el-button>
    </div>

    <manageList ref="manageListRef"></manageList>
    <addPlanPop ref="addPlanPopRef" @refresh="handleRefresh"></addPlanPop>
  </div>
</template>

<script>
import addPlanPop from './components/addPlanPop.vue'
import manageList from './components/manageList.vue'
export default {
  components:{
    manageList,
    addPlanPop,
  },
  data() {
    return {

    }
  },
  methods:{
    handleAddPlan() {
      this.$refs.addPlanPopRef.open()
    },
    handleRefresh() {
      this.$refs.manageListRef.handleRefresh()
    }
  },
}
</script>

<style scoped lang="less">
.header{
  display: flex;
  justify-content: space-between;
  .title{
    font-size: 18px;
    font-weight: 700;
    color: #333;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/miniProgram/poiCps/index.vue